// src/utils/layoutSlots.ts
//
// Places in the platform layout that a screen above it can render into (with a
// portal), so the content lands in the layout's own column rather than under
// its fixed sidebar.

/** The top of the platform layout's content column, under the header (layout_v2). */
export const LAYOUT_TOP_SLOT_ID = "layout-top-slot";
